var w = Object.defineProperty;
var v = (a, e, t) => e in a ? w(a, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : a[e] = t;
var d = (a, e, t) => (v(a, typeof e != "symbol" ? e + "" : e, t), t);
const h = {
  LOCAL: "local",
  STAGING: "staging",
  PROD: "prod"
}, m = {
  PROD: "https://accounts.credenza3.com",
  STAGING: "https://accounts.staging.credenza3.com",
  LOCAL: "http://localhost:8081"
};
function _(a) {
  switch (a.env) {
    case h.LOCAL:
      return m.LOCAL;
    case h.STAGING:
      return m.STAGING;
    case h.PROD:
      return m.PROD;
    default:
      throw new Error("Invalid sdk env");
  }
}
function f(a) {
  return a && a.__esModule && Object.prototype.hasOwnProperty.call(a, "default") ? a.default : a;
}
function p({ mustBeMetaMask: a = !1, silent: e = !1, timeout: t = 3e3 } = {}) {
  o();
  let s = !1;
  return new Promise((c) => {
    window.ethereum ? i() : (window.addEventListener("ethereum#initialized", i, { once: !0 }), setTimeout(() => {
      i();
    }, t));
    function i() {
      if (s)
        return;
      s = !0, window.removeEventListener("ethereum#initialized", i);
      const { ethereum: n } = window;
      n && (!a || n.isMetaMask) ? c(n) : (!e && console.error("@metamask/detect-provider:", a && n ? "Non-MetaMask window.ethereum detected." : "Unable to detect window.ethereum."), c(null));
    }
  });
  function o() {
    if (typeof a != "boolean")
      throw new Error("@metamask/detect-provider: Expected option 'mustBeMetaMask' to be a boolean.");
    if (typeof e != "boolean")
      throw new Error("@metamask/detect-provider: Expected option 'silent' to be a boolean.");
    if (typeof t != "number")
      throw new Error("@metamask/detect-provider: Expected option 'timeout' to be a number.");
  }
}
var k = p;
const A = /* @__PURE__ */ f(k), E = {
  OAUTH: "oauth",
  METAMASK: "metamask",
  WALLET_CONNECT: "walletconnect"
};
let r;
class P {
  constructor() {
    d(this, "name", "metamask");
    d(this, "sdk");
    d(this, "metamaskProvider");
  }
  async _initialize(e) {
    try {
      this.sdk = e;
      const t = await A();
      if (!t || !t.isMetaMask)
        return;
      this.metamaskProvider = t;
    } catch {
    }
  }
  _isAvailable() {
    if (!this.metamaskProvider)
      throw new Error("Metamask is not installed");
    return !0;
  }
  async _addChain(e) {
    var t;
    this._isAvailable(), await ((t = this.metamaskProvider) == null ? void 0 : t.request({
      method: "wallet_addEthereumChain",
      params: [
        {
          chainId: e.chainId,
          chainName: e.displayName,
          rpcUrls: [e.rpcUrl],
          blockExplorerUrls: [e.blockExplorer],
          nativeCurrency: {
            name: e.nativeCurrency.name,
            symbol: e.nativeCurrency.symbol,
            decimals: e.nativeCurrency.decimals || 18
          }
        }
      ]
    }));
  }
  async _switchChain(e) {
    if (this._isAvailable(), r)
      return r;
    r = this.metamaskProvider.request({ method: "eth_chainId" }).then((t) => t === e.chainId ? Promise.reject(new Error("SWITCH_CHAIN_NOT_REQUIRED")) : this._addChain(e)).then(() => this.metamaskProvider.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: e.chainId }]
    })).catch((t) => t.message === "SWITCH_CHAIN_NOT_REQUIRED" ? Promise.resolve() : Promise.reject(t)), await r, r = void 0;
  }
  async _getProvider() {
    return this._isAvailable(), new Proxy(this.metamaskProvider, {
      get: (e, t) => t !== "request" ? e[t] : async (...s) => (await this._switchChain(this.sdk.evm.getChainConfig()), e[t].apply(this.metamaskProvider, s))
    });
  }
  async login() {
    this._isAvailable(), await this._switchChain(this.sdk.evm.getChainConfig());
    const e = `${_(this.sdk)}/accounts/evm/auth`, t = await this.getAddress(), s = new URL(e);
    s.searchParams.append("client_id", this.sdk.clientId), s.searchParams.append("address", t);
    const o = await fetch(s.toString()), { message: c, nonce: i } = await o.json(), n = await this.metamaskProvider.request({ method: "personal_sign", params: [c, t] }), l = await fetch(e, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ signature: n, nonce: i })
    }), { access_token: u } = await l.json();
    await this.sdk._setAccessToken(u, E.METAMASK);
  }
  async getAddress() {
    this._isAvailable();
    const e = await this.metamaskProvider.request({ method: "eth_requestAccounts", params: [] });
    if (e != null && e[0])
      return e[0].toLowerCase();
    throw new Error("Cannot get metamask address");
  }
}
export {
  P as MetamaskExtension
};
